import React from 'react';
export function UrgencyBanner() {
  return <div className="w-full bg-amber-50 border-y border-amber-100 py-3" data-id="element-149">
      <div className="container mx-auto px-4 md:px-8" data-id="element-150">
        <div className="flex items-center justify-center" data-id="element-151">
          <div className="flex items-center" data-id="element-152">
            <div className="w-6 h-6 rounded-full bg-red-500 text-white flex items-center justify-center mr-2 flex-shrink-0" data-id="element-153">
              <span className="font-bold" data-id="element-154">!</span>
            </div>
            <p className="font-medium text-gray-900" data-id="element-155">
              <span className="font-bold text-red-600 mr-1" data-id="element-156">UPDATE:</span>
              Zenseat Cushions Are Selling Out FAST! Grab Yours NOW to get up to
              50% OFF + Fast FREE Shipping Across the US
            </p>
          </div>
        </div>
      </div>
    </div>;
}